import userInfo from "../../function/userInfo";
import i18n from "../../locales/i18n";
import * as API from "../ApiConfig";
import helper from "../transaction/transactionHelper";

export default {
  DoCreateProductTemplateOnce(productTemplate) {
    let formData = new FormData();
    const productTemplateData = {
      ...productTemplate.insertProductTemplate,
      productImageList: [],
    };
    formData.append("merchantId", userInfo.MerchantId());
    formData.append("skuGroupModelList", JSON.stringify(productTemplate.skuGroupModelList));
    productTemplate.insertProductTemplate.productImageList.forEach((file, index) => {
      let blob = helper.Base64ToBlob(file.rawString, file.fileType);
      formData.append(`File`, blob, file.fileName);
    });
    formData.append("productTemplate", JSON.stringify(productTemplateData));
    return API.peakRealTimeAPIForImport
      .post("/api/Product/CreateProductTemplateOnce", formData, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetSuggestProductCode() {
    let _input = {
      merchantId: userInfo.MerchantId(),
    };
    return API.peakRealTimeAPI
      .post("/api/Product/GetSuggestProductCode", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetUnitList(unitType, isUseMainDatabase = false) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      unitType: unitType,
      isDeleted: false,
      isUseMainDatabase: isUseMainDatabase,
    };

    return API.peakAPI.post("/api/Product/GetUnitList", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoCreateUnitOnce(unit) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      unit: unit,
    };

    return API.peakRealTimeAPIForTransaction
      .post("/api/Product/CreateUnitOnce", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateUnit(unit) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      unit: unit,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Product/EditUnit", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoVoidUnit(unitIdList) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      unitIdList: unitIdList,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Product/VoidUnit", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetSuggestUnitCode() {
    let _input = {
      merchantId: userInfo.MerchantId(),
    };
    return API.peakRealTimeAPI
      .post("/api/Product/GetSuggestUnitCode", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetProductTemplateById(input) {
    let _input = {
      productTemplateId: input,
      merchantId: userInfo.MerchantId(),
    };
    return API.peakRealTimeAPI
      .post("/api/Product/GetProductTemplateById", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateFavoriteProduct(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      productId: input.productId,
      favoriteTypeId: input.favoriteTypeId,
    };
    return API.peakAPI.post("/api/Product/UpdateFavoriteProduct", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoDeleteFavoriteProduct(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      productId: input.productId,
      financeTypeId: input.financeTypeId,
    };
    return API.peakAPI.post("/api/Product/DeleteFavoriteProduct", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetTransactionNumberByLotDetail(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      productTemplateId: input.productTemplateId,
      searchText: input.searchText,
    };
    return API.peakAPI
      .post("/api/Product/GetTransactionNumberByLotDetail", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetFavoriteProduct(financeTypeId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      financeTypeId: financeTypeId,
    };
    return API.peakAPI.post("/api/Product/GetFavoriteProduct", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoUpdateProductTemplateOnce(input) {
    let formData = new FormData();
    const productTemplateData = {
      ...input.insertProductTemplate,
      productImageList: [],
    };
    formData.append("isUpdateProductImage", input.isUpdateProductImage);
    formData.append("isUpdateRecordJournalCostOfGoodsSold", input.isUpdateRecordJournalCostOfGoodsSold);
    formData.append("merchantId", userInfo.MerchantId());
    formData.append("updateSkuGroupModelList", JSON.stringify(input.skuGroupModelList));
    if (
      input.isUpdateProductImage &&
      input.insertProductTemplate.productImageList &&
      input.insertProductTemplate.productImageList.length > 0
    ) {
      input.insertProductTemplate.productImageList.forEach((file, index) => {
        if (file.rawString.startsWith("data:")) {
          let blob = helper.Base64ToBlob(file.rawString, file.fileType);
          formData.append(`File`, blob, file.fileName);
        } else {
          productTemplateData.productImageList.push(file);
        }
      });
    }
    formData.append("productTemplate", JSON.stringify(productTemplateData));
    return API.peakRealTimeAPIForImport
      .post("/api/Product/UpdateProductTemplate", formData, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetProductDetailChartBySell(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      productTemplateId: input.productTemplateId,
      date: new Date().ToDateJsonString(),
      selectOptionType: input.selectOptionType,
    };
    return API.peakAPI
      .post("/api/DashBoard/GetProductDetailChartBySell", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetProductDetailChartByPurchase(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      productTemplateId: input.productTemplateId,
      date: new Date().ToDateJsonString(),
      selectOptionType: input.selectOptionType,
    };
    return API.peakAPI
      .post("/api/DashBoard/GetProductDetailChartByPurchase", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetProductDetailCostGraphSummary(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      productTemplateId: input.productTemplateId,
      year: input.year,
    };
    return API.peakAPI
      .post("/api/DashBoard/GetProductDetailCostGraphSummary", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetProductTemplateIdMonitoringList(type) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      type: type,
    };
    return API.peakAPI
      .post("/api/DashBoard/GetProductTemplateIdMonitoringList", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetProductTemplateMonitoringSummary(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      productTemplateId: input.productTemplateId,
      date: new Date().ToDateJsonString(),
      selectOptionType: input.selectOptionType,
    };
    return API.peakAPI
      .post("/api/DashBoard/GetProductTemplateMonitoringSummary", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoSetProductTemplateIdMonitoring(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      type: input.type,
      productTemplateIdList: input.productTemplateIdList,
    };
    return API.peakAPI
      .post("/api/DashBoard/SetProductTemplateIdMonitoring", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetStockPurchasePriceChangeChartModel(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      productTemplateId: input.productTemplateId,
      date: new Date().ToDateJsonString(),
      stockPriceChangeChartOptionType: input.stockPriceChangeChartOptionType,
    };
    return API.peakAPI
      .post("/api/DashBoard/GetStockPurchasePriceChangeChartModel", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetStockSellPriceChangeChart(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      productTemplateId: input.productTemplateId,
      date: new Date().ToDateJsonString(),
      stockPriceChangeChartOptionType: input.stockPriceChangeChartOptionType,
    };
    return API.peakAPI
      .post("/api/DashBoard/GetStockSellPriceChangeChart", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoVoidProductTemplate(productTemplateIdList) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      productTemplateIdList: productTemplateIdList,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Product/VoidProductTemplate", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },

  DoUpdateProductTemplateIsArchived(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      productTemplateIdList: input.productTemplateIdList,
      isArchived: input.isArchived,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Product/UpdateProductTemplateIsArchived", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetStockChangeFromDate(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      productTemplateId: input.productTemplateId,
      date: input.date,
    };

    return API.peakRealTimeAPI
      .post("/api/Product/GetStockChangeFromDate", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoAdjustProduct(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      productTemplateId: input.productTemplateId,
      date: input.date,
      amount: input.amount,
      language: i18n.locale,
    };
    return API.peakRealTimeAPI.post("/api/Product/DoAdjustProduct", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoUpdateProductTemplateForRecalculateCostofGoodsSold(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      productTemplateId: input.productTemplateId,
      fromDate: input.fromDate,
      toDate: input.toDate,
      language: i18n.locale,
    };
    return API.peakRealTimeAPIForTransaction
      .post(
        "/api/Product/UpdateProductTemplateForRecalculateCostofGoodsSoldByProductTemplateId",
        _input,
        userInfo.SetHeaderService()
      )
      .then((res) => {
        return res;
      });
  },
  DoAddProductPrice(input) {
    let _input = {
      productTemplateId: input.productTemplateId,
      financeType: input.financeType,
      name: input.name,
      price: input.amount,
      discountType: input.discountType,
      discount: input.discount,
    };
    return API.peakAPI.post("/api/Product/AddProductPrice", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoUpdateProductPrice(input) {
    let _input = {
      productTemplateId: input.productTemplateId,
      financeType: input.financeType,
      name: input.name,
      oldName: input.oldName,
      price: input.amount,
      discountType: input.discountType,
      discount: input.discount,
    };
    return API.peakAPI.post("/api/Product/UpdateProductPrice", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoDeleteProductPrice(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      productTemplateId: input.productTemplateId,
      financeType: input.financeType,
      name: input.name,
    };
    return API.peakAPI.post("/api/Product/DeleteProductPrice", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetProductPriceList(productTemplateId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      productTemplateId: productTemplateId,
    };
    return API.peakAPI.post("/api/Product/GetProductPriceList", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoVoidAdjustProduct(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      productTemplateId: input.productTemplateId,
      stockActivityId: input.stockActivityId,
      language: i18n.locale,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Product/DoVoidAdjustProduct", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  GetProductRemainStock(productTemplateIdList) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      productTemplateIdList: productTemplateIdList,
    };
    return API.peakAPI.post("/api/Product/GetProductRemainStock", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetStockActivityForSearchLotByTransaction(input) {
    const headers = userInfo.SetHeaderService().headers;
    const params = {
      productTemplateId: input.productTemplateId,
      transactionId: input.transactionId,
      transactionType: input.transactionType,
    };

    return API.peakAPI
      .get("/api/Product/GetStockActivityForSearchLotByTransaction", { params, headers })
      .then((res) => {
        return res;
      });
  },
  DoGetStockActivityDetailList(input) {
    let _input = {
      productTemplateId: input.productTemplateId,
      stockActivityIdList: input.stockActivityIdList,
    };
    return API.peakAPI
      .post("/api/Product/GetStockActivityDetailList", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  GetProductBeginningBalanceList(productTemplateId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      productTemplateId: productTemplateId,
    };
    return API.peakRealTimeAPI
      .post("/api/Product/GetProductBeginningBalanceList", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  UpdateProductBeginningBalance(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      productTemplateId: input.productTemplateId,
      beginningBalanceList: input.beginningBalanceList,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Product/UpdateProductBeginningBalance", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoValidateProductTemplateIssuedDocument(productTemplateId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      productTemplateId: productTemplateId,
    };
    return API.peakRealTimeAPI
      .post("/api/Product/ValidateProductTemplateIssuedDocument", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetSkuGroupByProductTemplateId(productTemplateId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      productTemplateId: productTemplateId,
    };
    return API.peakRealTimeAPI
      .post("/api/Product/GetSkuGroupByProductTemplateId", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoSetQueueRecordCostOfGoodSoldByProductTemplateId(productTemplateIdList) {
    let _input = {
      productTemplateIdList: productTemplateIdList,
    };
    return API.peakRealTimeAPIForImport
      .post("/api/Product/SetQueueRecordCostOfGoodSoldByProductTemplateId", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetTotalStockQueue() {
    const headers = userInfo.SetHeaderService().headers;
    const params = {};
    return API.peakRealTimeAPI.get("/api/Product/GetTotalQueue", { params, headers }).then((res) => {
      return res;
    });
  },
  DoUploadProductImageOne(input) {
    let formData = new FormData();
    formData.append("productTemplateId", input.productTemplateId);
    let blob = helper.Base64ToBlob(input.file.rawString, input.file.fileType);
    formData.append(`File`, blob, input.file.fileName);

    return API.peakRealTimeAPIForTransaction
      .post("/api/Product/UploadProductImageOne", formData, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetProductTemplateCodeByProductIdList(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      productTemplateIdList: input,
    };
    return API.peakAPI.post("/api/Product/GetProductTemplateCodeByProductIdList", _input, userInfo.SetHeaderService());
  },
  GetProductTemplateCodeByProductIdList(productTemplateIdList) {
    const input = {
      productTemplateIdList: productTemplateIdList,
    };
    return API.peakAPI
      .post("/api/Product/GetProductTemplateCodeByProductIdList", input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetRecommendProduct(input) {
    const headers = userInfo.SetHeaderService().headers;
    const params = {
      financeType: input.financeType,
      contactId: input.contactId,
    };

    return API.peakRealTimeAPI.get("/api/transaction/RecommendProduct", { params, headers }).then((res) => {
      return res;
    });
  },
  DoGetRecentlyProductDetail(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      productTemplateId: input.productTemplateId,
      financeType: input.financeType,
      contactId: input.contactId,
    };
    return API.peakAPI
      .post("/api/Product/GetRecentlyProductDetail", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetCountAllProductTemplate(input) {
    const headers = userInfo.SetHeaderService().headers;
    const params = {
      productTemplateType: input.productTemplateType,
    };

    return API.peakAPI.get("/api/Product/GetCountAllProductTemplate", { params, headers }).then((res) => {
      return res;
    });
  },
  DoGetAllProductTemplate(input) {
    const headers = userInfo.SetHeaderService().headers;
    const params = {
      pageNumber: input.pageNumber,
      pageSize: input.pageSize,
      productTemplateType: input.productTemplateType,
    };

    return API.peakAPI.get("/api/Product/GetAllProductTemplateWithSku", { params, headers }).then((res) => {
      return res;
    });
  },
  DoGetAutoCompleteProductTemplates(searchText, productType) {
    let _input = {
      searchText: searchText,
      productType: productType,
    };
    return API.peakRealTimeAPI
      .post("/api/Product/GetAutoCompleteProductTemplates", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetProductTemplateCacheCount() {
    return API.peakAPI
      .post("/api/Product/GetProductTemplateCacheCountByMerchantId", {}, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetProductTemplateCache(input) {
    let _input = {
      pageNo: input.pageNo,
      pageSize: input.pageSize,
    };
    return API.peakAPI
      .post("/api/Product/GetProductTemplateCacheByMerchantId", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetProductTemplateCacheCountByType(input) {
    let _input = {
      isArchived: input.isArchived,
      isDeleted: input.isDeleted,
      type: input.productTemplateType,
    };
    return API.peakAPI
      .post("/api/Product/GetProductTemplateCacheCountByType", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetProductTemplateCacheByType(input) {
    let _input = {
      pageNo: input.pageNo,
      pageSize: input.pageSize,
      isArchived: input.isArchived,
      isDeleted: input.isDeleted,
      type: input.productTemplateType,
    };
    return API.peakAPI
      .post("/api/Product/GetProductTemplateCacheByType", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetProductTemplateCacheById(productIdList) {
    let _input = {
      productTemplateIdList: productIdList,
    };
    return API.peakAPI
      .post("/api/Product/GetProductTemplateCacheById", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetProductTemplateCacheByCode(productCodeList) {
    let _input = {
      productTemplateCodeList: productCodeList,
    };
    return API.peakAPI
      .post("/api/Product/GetProductTemplateCacheByCode", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetProductTemplateRemainStockAmount(productIdList) {
    let _input = {
      productTemplateIdList: productIdList,
    };
    return API.peakAPI
      .post("/api/Product/GetProductTemplateRemainStockAmount", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
};
